const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReject(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "file-xmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7 9L10 12",
    stroke: "#E12727",
    style: {
      stroke: "#E12727",
      stroke: "color(display-p3 0.8825 0.1537 0.1537)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M10 9L7 12",
    stroke: "#E12727",
    style: {
      stroke: "#E12727",
      stroke: "color(display-p3 0.8825 0.1537 0.1537)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_3",
    d: "M6.2 1H9.28571L14 5.66667V11.8C14 12.9201 14 13.4802 13.782 13.908C13.5903 14.2843 13.2843 14.5903 12.908 14.782C12.4802 15 11.9201 15 10.8 15H6.2C5.0799 15 4.51984 15 4.09202 14.782C3.71569 14.5903 3.40973 14.2843 3.21799 13.908C3 13.4802 3 12.9201 3 11.8V4.2C3 3.0799 3 2.51984 3.21799 2.09202C3.40973 1.71569 3.71569 1.40973 4.09202 1.21799C4.51984 1 5.07989 1 6.2 1Z",
    stroke: "#E12727",
    style: {
      stroke: "#E12727",
      stroke: "color(display-p3 0.8825 0.1537 0.1537)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_4",
    d: "M9 1V4.4C9 4.96005 9 5.24008 9.10899 5.45399C9.20487 5.64215 9.35785 5.79513 9.54601 5.89101C9.75992 6 10.0399 6 10.6 6H14",
    stroke: "#E12727",
    style: {
      stroke: "#E12727",
      stroke: "color(display-p3 0.8825 0.1537 0.1537)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReject);
export default __webpack_public_path__ + "static/media/icon_reject.b5a58b53147977e45721d5cc7f87c22b.svg";
export { ForwardRef as ReactComponent };